module.exports = __webpack_public_path__ + "media/metronic/_theme/media/bg/bg-5-bcffd291e240762a08cf5989e12007ad.jpg";